<template>
  <div
    id="friends-landing-page"
    class="friends-page"
  >
    <fn-friends-intro
      v-if="page?.content?.section_options"
      :logo="page.content.section_options.friends_logo"
      :content="page.content.section_options.content"
      :section="page.content.section_options.friends_intro_options"
    />

    <template v-if="!isSoftLoggedin && !isAuthenticated">
      <fn-cms-section-loader
        v-if="page?.content?.content_slots?.b?.sections"
        :sections="page.content.content_slots.b.sections"
      />
    </template>

    <template v-if="(isSoftLoggedin || isAuthenticated) && !hasFriendsBenefit">
      <fn-cms-section-loader
        v-if="page?.content?.content_slots?.c?.sections"
        :sections="page.content.content_slots.c.sections"
      />
    </template>

    <template v-if="(isAuthenticated && hasFriendsBenefit) || (isSoftLoggedin && hasFriendsBenefit)">
      <fn-cms-section-loader
        v-if="page?.content?.content_slots?.d?.sections"
        :sections="page.content.content_slots.d.sections"
      />
    </template>
  </div>
</template>

<script>
export default defineComponent({
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useUserStore, {
      isSoftLoggedin: 'softLogin',
      isAuthenticated: 'getIsAuthenticated',
      hasFriendsBenefit: 'getHasFriendsBenefit',
    }),
  },
});
</script>
